import { render, staticRenderFns } from "./MyBankCard.vue?vue&type=template&id=70f44493&"
import script from "./MyBankCard.vue?vue&type=script&lang=ts&"
export * from "./MyBankCard.vue?vue&type=script&lang=ts&"
import style0 from "./MyBankCard.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports